import Error from "../../utils/error.coffee"
import translations from "../../translations"
import * as I18n from "../../services/i18n"

// Dropzone dos ANEXOS do método. Espelha MethodImageUploadHandler, com três
// diferenças de domínio:
//
//   - sem thumbnail: documento não tem preview de imagem;
//   - `maxFilesize: 5` (MB) e `acceptedFiles` com os 4 tipos — isso é ERGONOMIA,
//     não a regra. O backend valida de novo e é fail-closed (Fvs::MethodDocument
//     valida content_type e 5 MB; o vínculo valida 15 MB e 5 documentos por método);
//   - renomear: `display_name` é rótulo editável, imagem não tem equivalente.
//
// O hidden input emitido é `document_ids[]`, espelhando `image_ids[]`: é a chave
// que Services::Servicos::Servicos::Helper espera para transformar o upload
// órfão em vínculo ao salvar o serviço.
export default class MethodDocumentUploadHandler {
  // MIME types aceitos. Mesma lista de Fvs::MethodDocument::CONTENT_TYPES —
  // .csv chega como text/csv ou application/csv dependendo do SO/navegador.
  static ACCEPTED_MIME_TYPES = [
    'application/pdf',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'text/csv',
    'application/csv'
  ]

  static MAX_FILESIZE_MB = 5

  // Descobrimos os metodos pelo DOM, nao pelo `.method-ids`: aquele atributo so
  // e populado no EDIT (ids persistidos) e vem `[]` no NEW, entao o metodo
  // pre-construido por ServicosController#new ficava sem dropzone e o botao
  // "Adicionar anexos" era inerte. O id do form ja e a fonte da verdade (mesmo
  // `method_dom_id` do botao) e cobre new e edit sem depender do controller.
  call() {
    $('form[id^="js-method-document-form-"]').each((_index, form) => {
      this.initializeDropzone(form.id.replace('js-method-document-form-', ''))
    })
  }

  initializeDropzone(id) {
    const template = $(`#document-preview-template-${id}`)
    if (template.length == 0) return

    const previewTemplate = template.removeAttr('id').get(0).outerHTML

    let dropzone = $(`#js-method-document-form-${id}`).dropzone({
      createImageThumbnails: false,
      clickable: `#js-method-document-upload-button-${id}`,
      previewsContainer: `#document-preview-container-${id}`,
      previewTemplate: previewTemplate,
      acceptedFiles: MethodDocumentUploadHandler.ACCEPTED_MIME_TYPES.join(', '),
      maxFilesize: MethodDocumentUploadHandler.MAX_FILESIZE_MB
    })

    const dz = dropzone[0].dropzone

    dz.on('addedfile', (file) => {
      $(`#js-manage-method-documents-${id}`).find('.empty-message').hide()
      $(`#collapse-document-${id}`).find('.empty-message').hide()

      $(file.previewElement).find('.new-method-document').on('click', function (e) {
        $(e.currentTarget).on('confirmed', () => {
          dz.removeFile(file)
        })
      })

      if (!MethodDocumentUploadHandler.ACCEPTED_MIME_TYPES.includes(file.type)) {
        $(file.previewTemplate).hide()
        new Error.show_alert_flash_msg(I18n.t(translations(), 'servicos.show.method_documents.upload.type_error'))
        dz.removeFile(file)
        return
      }

      if (file.size > MethodDocumentUploadHandler.MAX_FILESIZE_MB * 1024 * 1024) {
        $(file.previewTemplate).hide()
        new Error.show_alert_flash_msg(I18n.t(translations(), 'servicos.show.method_documents.upload.size_error'))
        dz.removeFile(file)
      }
    })

    dz.on('complete', (file) => {
      $(file.previewTemplate).find('.overlay').hide()
    })

    // O backend responde 422 com `message` para arquivo recusado — é erro do
    // usuário, não do servidor. Mostramos a mensagem que veio do backend quando
    // existir, para não divergir da regra real.
    dz.on('error', (file, response) => {
      const message = (response && response.message)
        || I18n.t(translations(), 'servicos.show.method_documents.upload.type_error')

      $(file.previewTemplate).hide()
      new Error.show_alert_flash_msg(message)
    })

    dz.on('success', (file, response) => {
      const divHidden = $(`#${id}-document-hidden-input`)
      const itemsAttributesIndex = this.getIndexForAttributes(divHidden, 'items_attributes')
      const methodsAttributeIndex = this.getIndexForAttributes(divHidden, 'metodos_attributes')

      if (itemsAttributesIndex == null || methodsAttributeIndex == null) {
        console.error('method_documents_upload_handler: missing attribute index for divHidden', divHidden.attr('id'))
        new Error.show_alert_flash_msg(I18n.t(translations(), 'servicos.show.method_documents.upload.type_error'))
        dz.removeFile(file)
        return
      }

      file.serverId = response.method_document_id

      this.appendDocumentRow(divHidden, file, response)

      divHidden.append(`<input type='hidden'
                        id='document-hidden-${response.method_document_id}'
                        class="js-document-id-${response.method_document_id}"
                        name='servico_servico[fvses_attributes][0][items_attributes][${itemsAttributesIndex}][metodos_attributes][${methodsAttributeIndex}][document_ids][]'
                        value='${response.method_document_id}'/>`)
    })

    dz.on('removedfile', (file) => {
      if ($(`#js-manage-method-documents-${id}`).find('.dz-preview').length == 0) {
        $(`#js-manage-method-documents-${id}`).find('.empty-message').show()
        $(`#collapse-document-${id}`).find('.empty-message').show()
      }

      if (!file.serverId) return

      $(`#js-method-document-row-${file.serverId}`).remove()
      $(`#document-hidden-${file.serverId}`).remove()

      $.ajax({
        type: "delete",
        url: `/method_documents/${file.serverId}`
      })
    })
  }

  // Linha do anexo no slot "Anexos do Método". Nome e tamanho saem do arquivo
  // recém-enviado (`file`) e do que o backend devolveu (`display_name`) — nunca
  // de coluna do model, que nem existe ainda nesta tela.
  appendDocumentRow(container, file, response) {
    const name = response.display_name || file.name

    container.append(`
      <div class="row method-document-row" id="js-method-document-row-${file.serverId}">
        <div class="col-md-1"><i class="icon new icon-documentfile"></i></div>
        <div class="col-md-7">
          <strong class="file-name block js-method-document-name-${file.serverId}">${name}</strong>
          <span class="txt-grey file-size block">${this.humanFileSize(file.size)}</span>
        </div>
      </div>
    `)
  }

  humanFileSize(bytes) {
    if (!bytes) return '-'
    if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(2)} KB`
    return `${(bytes / (1024 * 1024)).toFixed(2)} MB`
  }

  // Mesma lógica de MethodImageUploadHandler: descobre os índices do nested
  // attributes a partir do input de ordenação do método já presente no DOM.
  getIndexForAttributes(element, key) {
    const ddContent = element.closest('div.dd-content')
    const attribute = ddContent.find('div.dd-method-div input.order-metodo').attr('name')
      || ddContent.find('input[name*="[metodos_attributes]"]').first().attr('name')

    if (!attribute) return null

    const match = new RegExp(`\\[${key}\\]\\[([^\\]]+)\\]`).exec(attribute)
    return match ? match[1] : null
  }
}
